module.exports = __webpack_public_path__ + "img/general-medicine.841a2d6f.png";